import { NativeElement2p8z5z0r9meck as NativeElement } from '../NativeElement.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ActivityIndicatorClass;
function ActivityIndicator() {
  if (ActivityIndicatorClass === VOID) {
    class $ extends NativeElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'span';
        this.native_1.classes_1.add_utx5q5_k$('spinner');
        this.native_1.setAttribute_j9pxft_k$('role', 'status');
        this.native_1.setAttribute_j9pxft_k$('aria-label', 'Loading');
      }
    }
    initMetadataForClass($, 'ActivityIndicator');
    ActivityIndicatorClass = $;
  }
  return ActivityIndicatorClass;
}
function ActivityIndicator$_get_shown_$ref_61t2d1(p0) {
  return constructCallableReference(() => p0.get_shown_iyiju0_k$(), 0, 0, 79, VOID, [p0]);
}
function ActivityIndicator$_set_shown_$ref_zcnirl(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_shown_mavbz5_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 80, VOID, [p0]);
}
//region block: exports
export {
  ActivityIndicator as ActivityIndicatork1oa7i2hevyv,
  ActivityIndicator$_get_shown_$ref_61t2d1 as ActivityIndicator$_get_shown_$ref_61t2d12wpeiijqwosf5,
  ActivityIndicator$_set_shown_$ref_zcnirl as ActivityIndicator$_set_shown_$ref_zcnirl1dri7v5nx6qpb,
};
//endregion

//# sourceMappingURL=ActivityIndicator.commonHtml.mjs.map
